import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledCustomSizeViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Large)};
  text-align: center;
`;

export const StyledSubtitleWrapper = styled.div`
  margin-bottom: ${({ theme }) => utils.rem(theme.Spacing.Size.Large)};
`;

export const StyledCustomSizeControlsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
`;

export const StyledWidthHeightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;

  & > * {
    flex: 1;
  }
  @media (min-width: ${({ theme }) => theme.Screen.Size.Large}px) {
    flex-direction: row;
  }
`;

export const StyledUnitsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.Small)};
  margin-top: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export const StyledUnitButtonWrapper = styled.div<{ isSelected?: boolean }>`
  flex: 1 1 calc(50% - ${({ theme }) => utils.rem(theme.Spacing.Size.Small)});
  flex-wrap: wrap;
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Small)};
  background-color: ${({ theme }) => theme.Color.Neutrals.Paper};
  outline: ${({ isSelected, theme }) =>
    isSelected
      ? `${utils.rem(theme.Border.Size.Small)} solid ${theme.Color.Brand.Primary}`
      : 'none'};

  & button {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.Screen.Size.Large}px) {
    flex: 1 1 calc(25% - ${({ theme }) => utils.rem(theme.Spacing.Size.Small)});
  }
`;

export const StyledConfirmButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  margin-top: ${({ theme }) => utils.rem(theme.Spacing.Size.Large)};
`;
